export const shouldLoad = () => document.querySelector('[data-controller="password-strength"]') !== undefined;
